import invoiceStatus from 'src/constants/enums/invoiceStatus';

export const isPaymentArrangementsDisabled = (state) => state.isPaymentArrangementsDisabled;
export const invoices = (state) => state.invoices;
export const outstandingInvoices = (state) => state.invoices.filter((item) => item.remaining > 0);
export const paidInvoices = (state) => state.invoices.filter((item) => !outstandingInvoices(state).includes(item));
export const payableInvoices = (state, getters) =>
  getters.outstandingInvoices.filter((item) => item.statusId !== invoiceStatus.AutomatischeIncasso);
export const paymentArrangementInvoices = (state) =>
  state.invoices.filter((item) => item.statusId === invoiceStatus.Betalingsregeling);
export const isLoadingInvoices = (state) => state.isLoadingInvoices;
export const paymentArrangements = (state) => state.paymentArrangements;
export const isLoadingAttachments = (state) => state.isLoadingAttachments;
export const hasUnproccessedPaymentArrangments = (state) => state.hasUnproccessedPaymentArrangments;
